<template>
    <div>
        <h1>How to use app</h1>
        <p>Left click on each colored block and type player name to know who is where.</p>
        <p>Use button "Click to match" to switch between renaming players and marking who you fought.</p>
        <p>Right click to "eliminate" player from matchmaking (ALWAYS eliminate the block where you are located). Alternatively use "Click to eliminate" button to eliminate.</p>
        <p>Use "Undo matched" to undo last entry in matchmaking history in case you clicked wrong player.</p>
        <p>If you wish to load original match history after someone is eliminated, use "Load original match history" button.</p>
        <h4>For mobile:</h4>
        <p>Tap to click (renaming/matching).</p>
        <p>Tap&hold to right click (eliminating). Right click might not work on iOS for some reason... But!</p>
        <p></p>
        <p>Now you can use "Click to eliminate" button to switch between matching or eliminating players.</p>
    </div>
</template>

<script>
    export default {
        name: "HowToUse"
    }
</script>

<style>
</style>